import { b as __makeTemplateObject, _ as __rest, a as __assign } from './_tslib-4c7d6ae2.js';
import React__default from 'react';
import styled from 'styled-components';
import { space, variant } from 'styled-system';
import { e as TextSmall } from './Typography-68c7e963.js';
import { m as mixins } from './mixins-9b684934.js';
import { c as colors } from './variables-80f55df9.js';

var SelectorColor = {
    TURQUOISE: colors.turquoiseDefault,
};
var SelectorVariant;
(function (SelectorVariant) {
    SelectorVariant["SOLID"] = "solid";
    SelectorVariant["OUTLINE"] = "outline";
})(SelectorVariant || (SelectorVariant = {}));
var SelectorContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n\n    ", "\n"], ["\n    display: flex;\n    flex-wrap: wrap;\n    gap: 4px;\n\n    ", "\n"])), space);
var Selector = styled.button(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    border-radius: 200px;\n    height: 34px;\n    max-width: 326px;\n    padding: 8px 12px;\n    cursor: pointer;\n\n    > * {\n        ", "\n    }\n\n    ", "\n"], ["\n    border-radius: 200px;\n    height: 34px;\n    max-width: 326px;\n    padding: 8px 12px;\n    cursor: pointer;\n\n    > * {\n        ", "\n    }\n\n    ", "\n"])), mixins.ellipsis(10, 14, 1), function (props) {
    var _a;
    return variant({
        prop: "variant",
        variants: (_a = {},
            _a[SelectorVariant.SOLID] = {
                color: "".concat(colors.white),
                background: "".concat(props.color),
                border: "1px solid ".concat(props.color)
            },
            _a[SelectorVariant.OUTLINE] = {
                color: "".concat(colors.grey.grey600),
                background: "".concat(colors.white),
                border: "1px solid ".concat(colors.grey.grey600),
                "@media (hover: hover)": {
                    "&:hover": {
                        background: "".concat(props.color),
                        color: "".concat(colors.white),
                    }
                },
                "@media (hover: none)": {
                    "&:active": {
                        background: "".concat(props.color),
                        color: "".concat(colors.white),
                    }
                }
            },
            _a),
    });
});
Selector.defaultProps = {
    variant: SelectorVariant.OUTLINE,
};
function Selectors(_a) {
    var selectors = _a.selectors, styleProps = __rest(_a, ["selectors"]);
    return (React__default.createElement(SelectorContainer, __assign({}, styleProps), selectors.map(function (_a, i) {
        var text = _a.text, variant = _a.variant, testId = _a.testId, onClick = _a.onClick;
        return (React__default.createElement(Selector, { key: i, variant: variant, color: SelectorColor.TURQUOISE, onClick: onClick, "data-testid": testId },
            React__default.createElement(TextSmall, null, text)));
    })));
}
var templateObject_1, templateObject_2;

export { Selectors as S, SelectorVariant as a };
//# sourceMappingURL=Selectors-92acebf1.js.map
